var React = require('react');

function IconMinusInline (props) {
    return React.createElement("path",props);
}

IconMinusInline.defaultProps = {"d":"M43.6428571,28.2 L3.35714286,28.2 C1.51071429,28.2 0,26.61375 0,24.675 C0,22.73625 1.51071429,21.15 3.35714286,21.15 L43.6428571,21.15 C45.4892857,21.15 47,22.73625 47,24.675 C47,26.61375 45.4892857,28.2 43.6428571,28.2 Z"};

module.exports = IconMinusInline;

IconMinusInline.default = IconMinusInline;
